import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import Commodities from "./../../../Images/commodities.png";
import Commodities from "./../../../Images/home-products/commodities.png";
import CommoditiesFAQ from "./CommoditiesFAQ/CommoditiesFAQ";
import { useEffect } from "react";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
function CommoditiesProduct() {
  const [cookies, setCookie] = useCookies(['LeadId']);
  // let navigate = useNavigate();
  // const routeChange = () => {
  //   let path = `/AllEquities`;
  //   navigate(path);
  // };
  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Commodities Note",
      "mx_Custom_1": "Commodities",
      "mx_Custom_2": "Commodities page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      {/* <div>IPO Product testing</div> */}
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={Commodities} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>Commodities</span>
                </h3>
                <p>
                  A commodity market is one that deals in trading raw materials
                  or primary products rather than manufacturing products, such
                  as cocoa, fruit, and sugar. Commodity pricing is primarily
                  influenced by economic development and technological advances,
                  supply, demand, and scarcity. Commodities can be a promising
                  way for investors to diversify their portfolios beyond
                  traditional securities. Because commodity prices tend to move
                  in opposition to stock prices, some investors rely on
                  commodities during periods of market volatility.
                </p>
                {/* <a>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why Commodities</span>
                </h3>
                <p>
                  Commodity prices are a leading indicator of economic growth. Commodity funds have historically had
                  low correlation with stock market movements, making them a
                  valuable source of diversification in a portfolio. They tend
                  to rise in tandem with inflation, making commodities one of
                  the few assets that benefit from inflation.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <CommoditiesFAQ />
    </>
  );
}
export default CommoditiesProduct;
